import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from 'src/guard/authGuard/auth.guard';
import { PermissionGuard } from 'src/guard/permission/permission-guard.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'home',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: { slug: 'home' },
  },
  {
    path: 'calibration',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./calibration/calibration.module').then(m => m.CalibrationModule),
    data: { slug: 'calibration' },
  },
  {
    path: 'verification',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./verification/verification.module').then(m => m.VerificationModule),
    data: { slug: 'verification' },
  },
  {
    path: 'new-issue',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./new-issue/issue.module').then(m => m.IssueModule),
    data: { slug: 'new-issue' }
  },
  {
    path: 'log-issue/:id',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./log-issue/log-issue.module').then(m => m.LogIssueModule),
    data: { slug: 'new-issue' },
  },
  {
    path: 'data-scrub',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./data-scrub/data-scrub.module').then(m => m.DataScrubModule),
    data: { slug: 'data-scrub' },
  },
  {
    path: 'manage-sensor',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./manage-sensor/manage-sensor.module').then(m => m.ManageSensorModule ),
    data: { slug: 'manage-sensor' },
  },
  {
    path: 'portal-logs',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./portal-logs/portal-logs.module').then(m => m.PortalLogsModule ),
    data: { slug: 'portal-logs' },
  },
  {
    path: 'reason',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./reason/reason.module').then(m => m.ReasonModule ),
    data: { slug: 'reason' },
  },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
